import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.reduce.js";
import { uniCall, prepareApi, withStatics } from '../../utils';
prepareApi(['bcz_system']);
/**
 * 当前支持进行判断的隐私特性
 */
export var PrivacyFeature;
(function (PrivacyFeature) {
  /** 通知 */
  PrivacyFeature["Notification"] = "notification";
  /** 相机 */
  PrivacyFeature["Camera"] = "camera";
  /** 相册（写权限） */
  PrivacyFeature["AlbumWrite"] = "album-write";
  /** 相册（读写权限） */
  PrivacyFeature["AlbumReadWrite"] = "album-rw";
  /** 麦克风 */
  PrivacyFeature["Microphone"] = "microphone";
  /**
   * GPS 定位
   *
   * *客户端暂未针对这个 feature 做实现，所以始终会返回 `NotGranted`*
   */
  PrivacyFeature["GPS"] = "gps";
})(PrivacyFeature || (PrivacyFeature = {}));
/**
 * 隐私授权状态
 */
export var PrivacyGrantStatus;
(function (PrivacyGrantStatus) {
  /** 已授权 */
  PrivacyGrantStatus["Granted"] = "Granted";
  /** 未授权 */
  PrivacyGrantStatus["NotGranted"] = "NotGranted";
})(PrivacyGrantStatus || (PrivacyGrantStatus = {}));
var privacyResultMap = {
  // 已授权
  Authorized: PrivacyGrantStatus.Granted,
  AuthorizedAlways: PrivacyGrantStatus.Granted,
  AuthorizedWhenInUse: PrivacyGrantStatus.Granted,
  LimitedAuthorized: PrivacyGrantStatus.Granted,
  // 未授权
  NotDetermined: PrivacyGrantStatus.NotGranted,
  Restricted: PrivacyGrantStatus.NotGranted,
  Denied: PrivacyGrantStatus.NotGranted,
  Provisional: PrivacyGrantStatus.NotGranted
};
export default withStatics(getPrivacyInfo, {
  /** 支持的隐私特性 */
  feature: PrivacyFeature,
  /** 隐私授权状态 */
  grantStatus: PrivacyGrantStatus
});
/**
 * 获取系统权限信息
 */
export function getPrivacyInfo(opt) {
  return new Promise(function (resolve, reject) {
    try {
      var features = opt.features;
      window.bcz_system.onGetPrivacyInfo = function (res) {
        var result = Object.keys(res).reduce(function (ret, key) {
          ret[key] = privacyResultMap[res === null || res === void 0 ? void 0 : res[key]] || PrivacyGrantStatus.NotGranted;
          return ret;
        }, {});
        resolve({
          result: result,
          raw: res
        });
      };
      uniCall({
        api: 'getPrivacyInfo',
        param: {
          features: features
        }
      });
    } catch (err) {
      reject(new Error(err === null || err === void 0 ? void 0 : err['message']));
    }
  });
}